<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-default opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-12 mt-0 mt-md-4 mt-lg-0 d-block">
            <router-link
              :to="'/admin/trilha'"
              class="btn-link font-weight-normal text-white"
              title="Voltar para listagem de cursos"
              ><i class="fas fa-chevron-left mr-1"></i> Voltar</router-link
            >
          </div>
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-4 mb-2">
              Aqui você poderá atualizar as informações do curso de capacitação,
              o que inclui modificar a imagem do curso, a sua visibilidade para
              as startups e outras informações.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">
          <div
            class="card card-profile shadow vld-parent border-0"
            ref="course_image"
          >
            <div class="card-image">
              <img
                class="card-img-top rounded-top"
                :src="model.curso.image_url || placeholderImg"
                alt="Imagem curso"
              />
              <div class="image-overlay"></div>
            </div>
            <div class="card-body py-3">
              <h2 class="card-title mb-1">{{ model.curso.title }}</h2>
              <p class="description mb-0">{{ model.curso.subtitle }}</p>
              <p class="card-text mt-2 mb-0" v-if="model.curso.description">
                <span :title="model.curso.description">{{
                  truncate(model.curso.description)
                }}</span>
              </p>
              <p v-if="!model.curso.is_active" class="mt-2 mb-0">
                <badge type="warning" v-tooltip="'O curso está oculto'"
                  >Oculto</badge
                >
              </p>
              <hr class="mt-3 mb-4" />
              <div class="row">
                <div class="col text-center">
                  <file-select
                    v-model="model.image"
                    title="Selecione a foto de capa padrão do curso"
                    accept="image/*"
                    :mbSize="4"
                  ></file-select>
                  <br />
                  <button
                    v-if="model.image"
                    @click="handleSubmitImage"
                    class="btn btn-primary my-2 jump"
                  >
                    Salvar arquivo
                  </button>
                </div>
              </div>
              <p class="text-sm text-muted text-center mb-0">
                <i class="fas fa-info-circle mr-1"></i> A foto de capa do curso
                deve possuir tamanho máximo de 4MB e, prefrencialmente, ser do
                formato <b>PNG</b> ou <b>JPG</b> com dimensão de
                <b>460x200 pixels</b>.
              </p>
            </div>
          </div>
          <div class="col-12 text-center mt-3">
            <router-link
              :to="'/admin/trilha/cursos/' + model.curso.id + '/materiais'"
              class="btn btn-white"
              v-tooltip="'Gerenciar materiais do curso'"
              ><i class="fas fa-book text-dark-green mr-2"></i> Gerenciar
              materiais</router-link
            >
          </div>
        </div>

        <div class="col-xl-8">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">
                    Curso
                    <span class="text-danger">{{ model.curso.title }}</span>
                    <base-button
                      size="sm"
                      type="danger"
                      class="float-right"
                      @click="handleOpenModalRemove()"
                    >
                      <i class="fas fa-trash mr-1"></i> Deletar curso
                    </base-button>
                  </h3>
                </div>
              </div>
            </div>
            <template>
              <form role="form" ref="curso_form">
                <div class="row ml-1">
                  <h6 class="heading-small text-muted mb-4">
                    Informações básicas
                  </h6>
                </div>
                <div class="row ml-lg-2">
                  <div class="col-lg-6">
                    <base-input
                      label="Título do curso*"
                      v-model.trim="model.curso.title"
                      placeholder="Digite o título"
                    />
                  </div>
                  <div class="col-lg-6">
                    <label class="form-control-label d-block"
                      >Está ativo?
                      <i
                        class="fas fa-info-circle ml-1"
                        v-tooltip="
                          'Um curso <b>ativo</b> fica visível para as startups que possuem acesso, enquanto um curso <b>inativo</b> fica oculto para todas startups.'
                        "
                      ></i
                    ></label>
                    <base-input>
                      <base-switch
                        v-bind:value="model.curso.is_active"
                        @input="switchChangedHandler($event, 'is_active')"
                      />
                    </base-input>
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      label="Subtítulo do curso (opcional)"
                      v-model.trim="model.curso.subtitle"
                      placeholder="Digite o subtítulo"
                    />
                  </div>
                  <div class="col-lg-6">
                    <base-input
                      label="Apresentador (opcional)"
                      v-model.trim="model.curso.presenter"
                      placeholder="Digite o nome do apresentador"
                    />
                  </div>
                  <div class="col-lg-12">
                    <base-input label="Descrição do curso (opcional)">
                      <textarea
                        rows="2"
                        v-model="model.curso.description"
                        class="form-control"
                        placeholder="Escreva aqui..."
                      >
                      </textarea>
                    </base-input>
                  </div>
                  <div class="col-lg-6">
                    <base-input label="Objetivos do curso (opcional)">
                      <textarea
                        rows="2"
                        v-model="model.curso.goals"
                        class="form-control"
                        placeholder="Escreva aqui..."
                      >
                      </textarea>
                    </base-input>
                  </div>
                  <div class="col-lg-6">
                    <base-input label="Requisitos do curso (opcional)">
                      <textarea
                        rows="2"
                        v-model="model.curso.requirements"
                        class="form-control"
                        placeholder="Escreva aqui..."
                      >
                      </textarea>
                    </base-input>
                  </div>
                </div>
                <div class="row ml-lg-2">
                  <div class="col-12 text-center" v-if="error">
                    <base-alert type="danger">{{ error }}</base-alert>
                  </div>
                  <div class="col-12 text-center" v-if="success">
                    <base-alert type="success">{{ success }}</base-alert>
                  </div>
                </div>
                <div class="text-right">
                  <base-button
                    type="primary"
                    class="mt-3"
                    :custom="true"
                    @click="handleSubmitForm"
                    :disabled="!isValidModel"
                    >Salvar alterações</base-button
                  >
                </div>
              </form>
            </template>
          </card>
        </div>
      </div>
    </div>
    <modal
      :show.sync="modalRemove.show"
      modal-classes="modal-default modal-dialog-centered"
      body-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="text-center">
          <i class="fa fa-trash fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja
            <span class="text-danger">excluir o curso</span>?
          </h4>
          <p class="my-3">
            Ao confirmar, o curso "<b>{{ model.curso.title }}</b
            >" será removido e todas os possíveis materiais e avaliações
            vinculadas a ele serão perdidas.
          </p>
        </div>
        <div class="col-12 text-center mt-3" v-if="modalRemove.error">
          <base-alert type="danger"
            >Ocorreu um erro ao remover o curso. Tente novamente.</base-alert
          >
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="l-auto"
          @click="modalRemove.show = false"
        >
          Voltar
        </base-button>
        <base-button type="white" class="text-danger" @click="handleRemove()">
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api.js";

export default {
  name: "curso-form",
  data() {
    return {
      model: {
        curso: {
          id: "",
          title: "",
          is_active: true,
          subtitle: "",
          presenter: "",
          description: "",
          goals: "",
          requirements: "",
          image: null,
        },
        image: null,
      },
      requiredFields: ["title"],
      placeholderImg: "/img/pages/default_banner_course.jpg",
      success: "",
      error: "",
      modalRemove: {
        show: false,
        error: "",
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.curso_form,
      width: 90,
      height: 90,
    });
    try {
      this.model.curso.id = this.$route.params.id;
      const { data } = await api.get(`/admin/courses/${this.model.curso.id}`);
      data.is_active = Boolean(data.is_active);
      this.model.curso = data;
      loader.hide();
    } catch (e) {
      this.$toasted.error(
        "Ocorreu um erro ao recuperar as informações do curso"
      );
      this.$router.push("/admin/cursos");
    }
  },
  methods: {
    async handleSubmitImage() {
      this.error = this.success = "";
      const loader = this.$loading.show({
        container: this.$refs.course_image,
        width: 130,
        height: 130,
      });
      const course_image = this.model.image;
      if (!course_image) return;
      const data = new FormData();
      data.append("image", course_image, course_image.name);
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      try {
        await api.post(
          `/admin/courses/${this.model.curso.id}/images`,
          data,
          config
        );
        this.$toasted.show("Imagem do curso salva com sucesso");
        const { data: image } = await api.get(
          `/admin/courses/${this.model.curso.id}/images`
        );
        if (image) this.model.curso.image_url = image.url;
        this.model.image = null;
        this.success = "Imagem do curso atualizada com sucesso!";
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao salvar a imagem do curso");
        this.error =
          "Não foi possível alterar a imagem do curso. Por favor, tente novamente em alguns instantes.";
      }
      loader.hide();
    },
    async handleSubmitForm(e) {
      e.preventDefault();
      this.error = this.success = "";
      const loader = this.$loading.show({
        container: this.$refs.curso_form,
        width: 90,
        height: 90,
      });
      try {
        const courseData = this.model.curso;
        const { data } = await api.put(
          `/admin/courses/${courseData.id}`,
          courseData
        );
        Object.assign(this.model.curso, data);
        this.$toasted.show("Informações atualizadas com sucesso");
        this.success = "Curso atualizado com sucesso!";
      } catch (e) {
        const genericError = "Ocorreu um erro ao salvar as informações";
        const hasErrorResponseData = e.response && e.response.data;
        let customError = genericError;
        if (hasErrorResponseData) {
          const data = e.response.data;
          if (data[0] && data[0].message) customError = data[0].message;
          else if (data.message) customError = data.message;
        }
        this.error = hasErrorResponseData
          ? customError
          : "Não foi possível salvar as informações. Por favor, tente novamente em alguns instantes.";
        this.$toasted.error(genericError);
      }
      loader.hide();
    },
    switchChangedHandler(event, obj) {
      if (typeof event === "boolean") this.model.curso[obj] = event;
    },
    truncate(text, stop = 150, clamp = "...") {
      if (!text) return "N/A";
      return text.slice(0, stop) + (stop < text.length ? clamp : "");
    },
    handleOpenModalRemove() {
      this.modalRemove.error = "";
      this.modalRemove.show = true;
    },
    async handleRemove() {
      this.modalRemove.error = false;
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_delete,
        width: 160,
        height: 160,
        opacity: 0,
      });
      try {
        await api.delete(`/admin/courses/${this.$route.params.id}`);
        this.$toasted.show("Curso removido com sucesso");
        this.modalRemove.show = false;
        this.$router.push("/admin/trilha");
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao remover o curso");
        this.modalRemove.error = true;
      } finally {
        loader.hide();
      }
    },
  },
  computed: {
    isValidModel() {
      const curso = this.model.curso;
      for (const key of this.requiredFields) {
        if (curso[key] === "") return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.card-img-top {
  height: 200px;
  margin: auto;
  object-fit: cover;
}

.card-image {
  position: relative;
  height: 200px;
}

.image-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0.2;
  transition: 0.5s ease;
  background: rgba(0, 0, 0, 0.5);
}

.card:hover .image-overlay {
  opacity: 1;
}
.jump {
  animation: jump 1.5s 0s forwards cubic-bezier(0.84, -0.54, 0.31, 1.19)
    infinite;
}

@keyframes jump {
  0% {
    transform: none;
  }
  50% {
    transform: translateY(-2em);
  }
}
</style>
